import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { QrCode } from "lucide-react";
import { useStationContext } from "../context/stationContext";
import { useTranslation } from "react-i18next";

const Home: React.FC = () => {
  const navigate = useNavigate();
  const { setStationId, setConnectorId } = useStationContext();
  const { lang } = useParams<{ lang: string }>();
  const { t } = useTranslation();

  useEffect(() => {
    localStorage.removeItem("stationId");
    localStorage.removeItem("connectorId");
    localStorage.removeItem("sessionId");
    setStationId("");
    setConnectorId("");
  }, []);

  const handleClick = () => {
    navigate(`/${lang}/scanner`);
  };

  return (
    <div className="min-h-screen w-full flex flex-col items-center justify-center p-4">
      <h1 className="text-xl font-bold text-gray-800 mb-8 text-center">
        {t("home.title")}
      </h1>
      <div className="flex w-full left-0 px-4 items-center justify-center bottom-0 h-[100px]">
        <button
          onClick={handleClick}
          className="p-2 flex justify-center items-center py-8 gap-2 bottom-4 rounded-3xl w-full  bg-green-600 hover:bg-green-700 text-white text-center cursor-pointer"
        >
          <QrCode className="w-5 h-5" />
          {t("home.start")}
        </button>
      </div>
    </div>
  );
};

export default Home;
